import { memo } from 'react'

import HighlightedText from 'common-components/HighlightedText'

import { useGetUserTtsCreditLimitData } from '../hooks'
import * as Styled from './styled'
import { useSelector } from 'react-redux'
import { ttsSelectors } from 'store/features/tts/selectors'
import { LoadingSkeleton } from 'common-components'
import { REF_LINKS } from 'consts/refLinks'

interface IProps {
  isTtsGenerationLoading: boolean
}

const CreditsLimit: React.FC<IProps> = (props: IProps) => {
  const { isTtsGenerationLoading } = props

  const { ttsLimitMessage, ttsLimitButtonAction, isUpgradableSubscription } =
    useGetUserTtsCreditLimitData()

  const isUserTtsCreditsLoading = useSelector(
    ttsSelectors.isTtsCreditLimitLoading
  )
  return (
    <Styled.CreditsLimitContainer
      onClick={() =>
        ttsLimitButtonAction({ ref: REF_LINKS.V_EDITOR_TTS_GENERATE })
      }
      $isTtsGenerationLoading={isTtsGenerationLoading}
      $isUserTtsCreditsLoading={isUserTtsCreditsLoading}
    >
      {isUserTtsCreditsLoading ? (
        <LoadingSkeleton />
      ) : (
        <>
          {isUpgradableSubscription && <Styled.PremiumIcon />}
          <Styled.LimitText
            type="h5"
            color="secondarySemiDark"
            lineHeight="16px"
            align="center"
          >
            <HighlightedText
              text={ttsLimitMessage}
              elementType="span"
              attributes={{
                className: 'highlightedText'
              }}
            />
          </Styled.LimitText>
        </>
      )}
    </Styled.CreditsLimitContainer>
  )
}

export default memo(CreditsLimit)
